import React, { useState, useEffect, useMemo } from "react";
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import { Button, Tree, Space, Input } from "antd";

const { Search } = Input;

const defaultData = [
  {
    title: "0-0-ss",
    key: "0-0",
    children: [
      {
        title: "0-0-0-r",
        key: "0-0-0",
        children: [
          { title: "0-0-0-0-t", key: "0-0-0-0" },
          { title: "0-0-0-1-y", key: "0-0-0-1" },
          { title: "0-0-0-2-u", key: "0-0-0-2" },
        ],
      },
      {
        title: "0-0-1",
        key: "0-0-1",
        children: [
          { title: "0-0-1-0", key: "0-0-1-0" },
          { title: "0-0-1-1", key: "0-0-1-1" },
          { title: "0-0-1-2", key: "0-0-1-2" },
        ],
      },
      { title: "0-0-2", key: "0-0-2" },
    ],
  },
  {
    title: "0-1",
    key: "0-1",
    children: [
      {
        title: "0-1-0",
        key: "0-1-0",
        children: [
          { title: "0-1-0-0", key: "0-1-0-0" },
          { title: "0-1-0-1", key: "0-1-0-1" },
          { title: "0-1-0-2", key: "0-1-0-2" },
        ],
      },
      {
        title: "0-1-1",
        key: "0-1-1",
        children: [
          { title: "0-1-1-0", key: "0-1-1-0" },
          { title: "0-1-1-1", key: "0-1-1-1" },
          { title: "0-1-1-2", key: "0-1-1-2" },
        ],
      },
      { title: "0-1-2", key: "0-1-2" },
    ],
  },
  { title: "0-2-he", key: "0-2" },
]


const getParentKey = (key, tree) => {
  let parentKey;
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    if (node.children) {
      if (node.children.some((item) => item.key === key)) {
        parentKey = node.key;
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children);
      }
    }
  }
  return parentKey;
};

const TreeFilter = (item, search, options = defaultData, data) => {
  const Filter = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
    const [checkedKeys, setCheckedKeys] = useState([]);
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [autoExpandParent, setAutoExpandParent] = useState(true);
    useEffect(() => {
      // 为了解决用户不点搜索 头部tag为undefined的问题
      setCheckedNodesTitle(data.checkedNodesTitle)
      setCheckedKeys(selectedKeys);
    }, [selectedKeys]);

    // 数组扁平化便于后面搜索
    const [dataList, setDataList] = useState()
    const generateList = (data, arr) => {
      for (let i = 0; i < data.length; i++) {
        const node = data[i];
        const { key } = node;
        arr.push({
          key,
          title: key,
        });
        if (node.children) {
          generateList(node.children, arr);
        }
      }
    };

    const flattenList = () => {
      let arr = []
      generateList(options, arr)
      setDataList(arr)
    }



    useEffect(() => {
      flattenList()
    }, [options])

    const handleSearch = () => {
      setSelectedKeys(checkedKeys || data.values);
      search({
        column_text: item.title,
        column_name: item.dataIndex,
        values: checkedKeys,
        column_type: 4,
        type: 'tree',
        checkedNodesTitle
      })
      confirm();
    };
    const handleReset = (clearFilters) => {
      clearFilters();
    };

    // const treeData = options

    const treeData = useMemo(() => {
      const loop = (data) =>
        data.map((item) => {
          const strTitle = item.title;
          const index = strTitle.indexOf(searchValue);
          const beforeStr = strTitle.substring(0, index);
          const afterStr = strTitle.slice(index + searchValue.length);
          const title =
            index > -1 ? (
              <span>
                {beforeStr}
                <span style={{ color: "red" }}>{searchValue}</span>
                {afterStr}
              </span>
            ) : (
              <span>{strTitle}</span>
            );
          if (item.children) {
            return {
              title,
              key: item.key,
              strTitle: strTitle,
              children: loop(item.children),
            };
          }
          return {
            title,
            strTitle: strTitle,
            key: item.key,
          };
        });
      return loop(options);
    }, [searchValue]);

    const onExpand = (newExpandedKeys) => {
      setExpandedKeys(newExpandedKeys);
      setAutoExpandParent(false);
    };

    const onSearch = (value) => {
      const newExpandedKeys = dataList
        .map((item) => {
          if (item.title.indexOf(value) > -1) {
            return getParentKey(item.key, options);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);
      setExpandedKeys(newExpandedKeys);
      setSearchValue(value);
      setAutoExpandParent(true);
    };

    const [checkedNodesTitle, setCheckedNodesTitle] = useState()
    const onCheck = (checkedKeys, info) => {
      let checkedNodes = []
      if (info.checkedNodes && info.checkedNodes.length) {
        checkedNodes = info.checkedNodes.map(v => v.strTitle)
      }
      setCheckedNodesTitle(checkedNodes)
      setCheckedKeys(checkedKeys);
    };

    return (
      <div
        style={{
          padding: 8,
        }}
      // onKeyDown={(e) => e.stopPropagation()}
      >
        <Search
          style={{
            marginBottom: 8,
          }}
          placeholder="Search"
          onSearch={onSearch}
        />
        <Tree
          checkable
          onExpand={onExpand}
          onCheck={onCheck}
          checkedKeys={checkedKeys}
          expandedKeys={expandedKeys}
          autoExpandParent={autoExpandParent}
          treeData={treeData}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch()}
            icon={<SearchOutlined />}
            style={{
              width: 90,
            }}
          >
            搜索
          </Button>
          <span style={{ visibility: "hidden" }}>-</span>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            style={{
              width: 90,
            }}
          >
            清空
          </Button>
        </Space>
      </div>
    );
  };

  return {
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys = [],
      confirm,
      clearFilters,
    }) => (
      <Filter
        setSelectedKeys={setSelectedKeys}
        selectedKeys={selectedKeys}
        confirm={confirm}
        clearFilters={clearFilters}
      />
    ),
    filterIcon: (filtered) => (
      <FilterOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
  };
};
export default TreeFilter;
